<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span> &copy; Fresh Clinics {{ new Date().getFullYear() }}</span>
    </footer>
</template>

<script>

export default {
    name: 'the-footer',
    props: {
        classes: {
            type: String,
        },
    },
    inject: {
      components:{
          default: {
          },
      },
    },
  }
;
</script>
<style >


</style>
